import { T } from "@tldraw/validate";
import { idValidator } from "../misc/id-validator.mjs";
const assetIdValidator = idValidator("asset");
function createAssetValidator(type, props, meta) {
  const propsValidator = props instanceof T.Validator ? props : props ? T.object(props) : T.jsonValue;
  return T.object({
    id: assetIdValidator,
    typeName: T.literal("asset"),
    type: T.literal(type),
    props: propsValidator,
    meta: meta ? T.object(meta) : T.jsonValue
  });
}
export {
  assetIdValidator,
  createAssetValidator
};
//# sourceMappingURL=TLBaseAsset.mjs.map
